module.exports = __webpack_public_path__ + "static/media/19ESCAP41.3c41e366.jpg";